import React, { useState, useEffect } from "react";
import EmailAPI from "../services/EmailAPI";
import "./css/SendEmail.css";

function SendEmail() {
  const [emailData, setEmailData] = useState({
    sendTo: "",
    subject: "",
    emailBodyPlainText: "",
    emailBodyHtml: "",
    messageId: "",
    sophisticationLevel: "",
    communicationChannel: "",
    contextAttributes: "",
  });

  // Load pre-filled data if available from sessionStorage
  useEffect(() => {
    const prefilledData = EmailAPI.loadEmailDataFromStorage();

    if (prefilledData) {
      console.log("Loaded pre-filled email data:", prefilledData);
      setEmailData((prevData) => ({
        ...prevData,
        ...prefilledData,
      }));
    }
  }, []);
  const [status, setStatus] = useState({
    message: "",
    isError: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmailData({
      ...emailData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate that at least one content field is filled
    if (
      !emailData.emailBodyPlainText.trim() &&
      !emailData.emailBodyHtml.trim()
    ) {
      setStatus({
        message: "Please provide either plain text or HTML content (or both).",
        isError: true,
      });
      return;
    }

    setStatus({ message: "Sending email...", isError: false });

    try {
      // Use EmailAPI service to send the email
      const response = await EmailAPI.sendEmail(emailData);
      console.log("Email sent successfully:", response);
      setStatus({ message: "Email sent successfully!", isError: false });

      // Clear the form after successful submission
      setEmailData({
        sendTo: "",
        subject: "",
        emailBodyPlainText: "",
        emailBodyHtml: "",
        messageId: "",
        sophisticationLevel: "",
        communicationChannel: "",
        contextAttributes: "",
      });

      // Clear the session storage
      EmailAPI.clearEmailDataFromStorage();
    } catch (error) {
      console.error("Error sending email:", error);
      setStatus({
        message: `Failed to send email: ${error.message}`,
        isError: true,
      });
    }
  };

  return (
    <div className="send-email-container">
      <h2>Send Email</h2>

      {status.message && (
        <div
          className={`status-message ${status.isError ? "error" : "success"}`}
        >
          {status.message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="email-form">
        <div className="form-group">
          <label htmlFor="sendTo">Send To</label>
          <input
            type="email"
            id="sendTo"
            name="sendTo"
            value={emailData.sendTo}
            onChange={handleChange}
            placeholder="recipient@example.com"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="subject">Subject</label>
          <input
            type="text"
            id="subject"
            name="subject"
            value={emailData.subject}
            onChange={handleChange}
            placeholder="Email Subject"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="emailBodyPlainText">Email Body (Plain Text)</label>
          <textarea
            id="emailBodyPlainText"
            name="emailBodyPlainText"
            value={emailData.emailBodyPlainText}
            onChange={handleChange}
            placeholder="Type your plain text email content here..."
            rows={8}
          />
        </div>

        <div className="form-group">
          <label htmlFor="emailBodyHtml">Email Body (HTML)</label>
          <textarea
            id="emailBodyHtml"
            name="emailBodyHtml"
            value={emailData.emailBodyHtml}
            onChange={handleChange}
            placeholder="Type your HTML email content here... (e.g., <p>Hello <strong>World</strong></p>)"
            rows={8}
          />
        </div>

        <div className="form-note">
          <p>
            <strong>Note:</strong> You can fill in either plain text, HTML, or
            both. If both are provided, the HTML version will be used for
            HTML-capable email clients, and the plain text version will be used
            as a fallback.
          </p>
        </div>

        <button type="submit" className="send-button">
          Send
        </button>
      </form>
    </div>
  );
}

export default SendEmail;
